import React, { useEffect, useState } from "react";
import Modal from "../../../../parts/modal-new";
import { oembed } from "@loomhq/loom-embed";
import ContentLoader from "react-content-loader";

const VideoCenterWatch = ({ sharedUrl, locals }) => {
  const webAppTheme = locals.activeUser.webAppTheme || "dark";

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [videoHTML, setVideoHTML] = useState(null);

  useEffect(() => {
    const getEmbedBody = async () => {
      try {
        const res = await oembed(`https://www.loom.com/share/${sharedUrl}`);
        setVideoHTML(res.html);
      } catch (e) {
        console.log({ e });
        setError(true);
      }
      setLoading(false);
    };

    if (sharedUrl) {
      getEmbedBody();
    }
  }, [sharedUrl]);

  return (
    <Modal
      width="700px"
      title={"Watch Loom"}
      className={"watch-loom-modal"}
      toClear={["sharedUrl"]}
    >
      {!loading ? (
        <div className="body">
          {error ? (
            <p className="font-bold">Error getting the video</p>
          ) : (
            <div dangerouslySetInnerHTML={{ __html: videoHTML }}></div>
          )}
        </div>
      ) : (
        <VideoLoading webAppTheme={webAppTheme} />
      )}
    </Modal>
  );
};

const VideoLoading = (props) => {
  const { webAppTheme } = props;

  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";

  return (
    <ContentLoader
      width={450}
      height={400}
      viewBox="0 0 450 400"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      {...props}
    >
      <rect x="43" y="304" rx="4" ry="4" width="271" height="9" />
      <rect x="44" y="323" rx="3" ry="3" width="119" height="6" />
      <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
    </ContentLoader>
  );
};

export default VideoCenterWatch;
